module.exports = __webpack_public_path__ + "static/text5-8fe7c845c94af3b61b274cfdf9b7ceba.svg";